var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedemptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#EFB71B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.35742C6.45039 2.35742 2.35681 6.451 2.35681 11.5007C2.35681 16.5503 6.45039 20.6439 11.5 20.6439C16.5497 20.6439 20.6433 16.5503 20.6433 11.5007C20.6433 6.451 16.5497 2.35742 11.5 2.35742ZM11.5 4.34411C15.4525 4.34411 18.6555 7.5492 18.6555 11.5007C18.6555 15.4521 15.4525 18.6561 11.5 18.6561C7.54758 18.6561 4.34461 15.4521 4.34461 11.5007C4.34463 7.5492 7.54758 4.34411 11.5 4.34411Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5496 6.53711V10.3926L12.3354 13.3343H10.6789L10.4504 10.3926V6.53711H12.5496ZM11.7499 14.291C12.026 14.291 12.2164 14.3481 12.3211 14.4624C12.4353 14.5671 12.4924 14.7575 12.4924 15.0335V15.719C12.4924 16.0046 12.4353 16.1997 12.3211 16.3044C12.2164 16.4092 12.026 16.4615 11.7499 16.4615H11.2644C10.9788 16.4615 10.7836 16.4092 10.6789 16.3044C10.5742 16.1997 10.5218 16.0046 10.5218 15.719V15.0335C10.5218 14.7575 10.5742 14.5671 10.6789 14.4624C10.7836 14.3481 10.9788 14.291 11.2644 14.291H11.7499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionIcon);
export default __webpack_public_path__ + "static/media/redemption-icon.d572c917f9209fd930e25d6e435f4b8c.svg";
export { ForwardRef as ReactComponent };